<template>
  <div class="block page15 f-r f-c">
    <PageHeader
      :title="moduleData['3_15_1_0']"
      :sub-title="moduleData['3_15_1_0_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page15-body f-r j-b">
      <div class="page15-body-left">
        <TableNav width="900px">
          <template v-slot:title> {{ PAGE_TEXT[commonLang].middleSchool }} </template>
          <template v-slot:subtitle> {{ PAGE_TEXT[commonLang].total }} {{catData1.count || 0}} {{ PAGE_TEXT[commonLang].unitSchool }} </template>
        </TableNav>
        <PTable :col-data="colData" :row-data="rowData1.slice(0,5)" style="height: 314px">
          <Empty :text="PAGE_TEXT[commonLang].noMiddleSchoolCoverage" v-if="!rowData1.slice(0,5).length"/>
        </PTable>
        <TableNav width="900px" style="margin-top: 40px">
          <template v-slot:title> {{ PAGE_TEXT[commonLang].higherEducation }}</template>
          <template v-slot:subtitle> {{ PAGE_TEXT[commonLang].total }} {{catData2.count || 0}} {{ PAGE_TEXT[commonLang].unitSchool }} </template>
        </TableNav>
        <PTable :col-data="colData" :row-data="rowData2.slice(0,5)" style="height: 314px">
          <Empty :text="PAGE_TEXT[commonLang].noHigherEducationCoverage" v-if="!rowData2.slice(0,5).length"/>
        </PTable>
        <div
          v-if="reportCustomization.showWater"
          class="page-tips2" style="padding-bottom: 27px;margin-top: 23px"
        >{{ PAGE_TEXT[commonLang].moreInfo }}</div>

      </div>
      <div class="page15-body-right">
        <div class="page15-body-right f-c">
          <div class="page9-map" id="page9Map">
            <Empty :text="PAGE_TEXT[commonLang].noSchoolCoverage" v-if="[
                        ...catData1.poi,
                        ...catData2.poi,
                    ].length === 0"/>
          </div>
          <div class="page9-map-legend f-r a-c">
            <div class="page9-map-legend-item f-r a-c">
              <div class="page9-map-legend-point point1"></div>
                {{ PAGE_TEXT[commonLang].middleSchoolLabel }}
            </div>
            <div class="page9-map-legend-item f-r a-c">
              <div class="page9-map-legend-point point2"></div>
                {{ PAGE_TEXT[commonLang].higherEducationLabel }}
            </div>
          </div>
          <div v-if="reportCustomization.showDataSource" class="page9-map-tips" >
            {{ PAGE_TEXT[commonLang].dataSource }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
    pageNum: String,
    cityInfo: {
        type: Object,
        default: () => {
            return {};
        },
    },
    catData1: {
        type: Object,
        default: () => {
            return {
                poi: []
            };
        },
    },
    catData2: {
        type: Object,
        default: () => {
            return {
                poi: []
            };
        },
    },
    moduleData: {
      type: Object,
      default: () => {
        return {
        };
      },
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    middleSchool: '周边中学（最多展示TOP5）',
    higherEducation: '周边高等院校（最多展示TOP5）',
    total: '共',
    unitSchool: '所',
    noMiddleSchoolCoverage: '当前区域暂无中学覆盖',
    noHigherEducationCoverage: '当前区域暂无高等院校覆盖',
    moreInfo: '>更多教育配套于APP「数据地图/市调详情_周边配套」中查看',
    noSchoolCoverage: '当前区域暂无学校覆盖',
    middleSchoolLabel: '中学',
    higherEducationLabel: '高等院校',
    dataSource: '数据来源：位置厂商数据，边界教育数据整合',
    serialNumber: '序号',
    name: '名称',
    level: '能级',
    distance: '距离'
  },
  'en': {
    middleSchool: 'Nearby Middle Schools (Top 5 Maximum)',
    higherEducation: 'Nearby Higher Education (Top 5 Maximum)',
    total: 'Total',
    unitSchool: 'schools',
    noMiddleSchoolCoverage: 'No middle school coverage in current area',
    noHigherEducationCoverage: 'No higher education coverage in current area',
    moreInfo: '',
    noSchoolCoverage: 'No school coverage in current area',
    middleSchoolLabel: 'Middle School',
    higherEducationLabel: 'Higher Education',
    dataSource: 'Data Source: Location vendor data, Boundary education data integration',
    serialNumber: 'No.',
    name: 'Name',
    level: 'Level',
    distance: 'Distance'
  }
};

    const store = useStore()
    const colData = computed(() => [
      { prop: "index", width: "67px", label: PAGE_TEXT[props.commonLang].serialNumber },
      { prop: "name", width: "312px", label: PAGE_TEXT[props.commonLang].name },
      { prop: "educationalLevel", width: "255px", label: PAGE_TEXT[props.commonLang].level },
      { prop: "distanceKilo", width: "265px", label: PAGE_TEXT[props.commonLang].distance, subLabel: "km" },
    ]);
    const rowData1 = computed(() => {
        return props.catData1.poi.map((el,index) => {
            let _index = index + 1
            return {
                index: _index < 10 ? ('0' + _index) : _index,
                ...el
            }
        })
    });
    const rowData2 = computed(() => {
        return props.catData2.poi.map((el,index) => {
            let _index = index + 1
            return {
                index: _index < 10 ? ('0' + _index) : _index,
                ...el
            }
        })
    });
    let map = shallowRef(null);
    const addMaker = (amap, map, newData, color) => {
        let markerList = [];
        newData.forEach((v) => {
          let marker = new amap.Marker({
            position: new amap.LngLat(
              v.location.split(",")[0],
              v.location.split(",")[1]
            ),
            content: `<div style="width: 12px;height: 12px; border-radius: 50%;background: ${color};"></div>`
          });
          markerList.push(marker);
        });
        map.add(markerList);
    };
    onMounted(() => {
        AMapLoader.load({
            key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap) => {
          map = new AMap.Map("page9Map", {
            WebGLParams: {
                preserveDrawingBuffer:true
            },
            dragEnable: false,
            zoomEnable: false,
            zoom: store.getters.mapZoom, //初始化地图级别
            center: props.cityInfo.location.split(","), //初始化地图中心点位置
          });
          addMaker(AMap, map,props.catData1.poi, '#1644FF');
          addMaker(AMap, map,props.catData2.poi, '#FF8116');
          if (props.cityInfo.is_polygon) {
            mapAddPolygonV2(props.cityInfo?.polygon || '', map)
          } else {
            mapAddCircle(props.cityInfo, map);
          }
          addMapCenter(AMap, map, props.cityInfo.location)

        // 等待地图渲染
        const totalCount = props.catData1.poi.length + props.catData2.poi.length
        const delay = getMapDelayByMarkerCount(totalCount || 0)
        drawMapKeepAlive(delay).catch((e) => {})

        map.setFitView()
      })
      .catch((e) => {
          console.log(e);
      });
    });
</script>

<style lang="less">
.page15 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page15-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
    td,
    th {
      height: 50px !important;
    }
    .page15-body-left {
      width: 900px;
    }
    .page15-body-right {
      width: 853px;
      .page9-map {
        width: 100%;
        height: 760px;
      }
      .page9-map-legend {
        flex-grow: 1;
        padding: 23px 0 23px 46px;
        .page9-map-legend-item {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-right: 76px;
        }
        .page9-map-legend-item:last-child {
          margin-right: 0;
        }
        .page9-map-legend-icon {
          width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 12px;
        }
        .icon1 {
          background-image: url("~@/assets/机场.png");
        }
        .icon2 {
          background-image: url("~@/assets/火车站.png");
        }
        .icon3 {
          background-image: url("~@/assets/高铁站.png");
        }
        .page9-map-legend-point {
          width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .point1 {
          background-color: #1644ff;
        }
        .point2 {
          background-color: #ff8116;
        }
      }
      .page9-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
